import { get } from '@core/api/baseApi';
import { GetTemplateResponse } from '@core/types';
import { SearchParams } from '../hooks/useFilters';

export const getTemplates = (filters: SearchParams): Promise<GetTemplateResponse> => get('/ReportTemplates', {
    params: filters
});
